import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import { Navbar } from "../components/Navbar";
import { Seo } from "../components/Seo";
import { Footer } from "../components/Footer";
import { PLANS, PLANS_PAGE } from "../data/plans";
import { COMPANY } from "../data/company";
import { CheckoutButton } from "../components/CheckoutButton";

export const plansJsonLd = () => ({
  "@context": "https://schema.org",
  "@graph": PLANS.map((p) => ({
    "@type": "Product",
    name: `WanderlyMe ${p.name}`,
    description: p.tagline,
    brand: { "@type": "Brand", name: "WanderlyMe" },
    url: `${COMPANY.site}/plans#${p.id}`,
    offers: { "@type": "Offer", price: p.price_aud, priceCurrency: "AUD", availability: "https://schema.org/InStock", url: `${COMPANY.site}/plan-with-us?plan=${p.id}`, seller: { "@type": "Organization", name: "WanderlyMe" } },
  })),
});

export default function Plans() {
  return (
    <div className="min-h-screen grain relative" data-testid="plans-page">
      <Seo title={PLANS_PAGE.title} description={PLANS_PAGE.description} path="/plans" jsonLd={plansJsonLd()} />
      <Navbar />
      <main className="max-w-5xl mx-auto px-6 py-12">
        <span className="inline-flex text-xs uppercase tracking-widest text-[#C8553D] mb-4">Pricing</span>
        <h1 className="font-display text-4xl sm:text-5xl tracking-tight mb-4">{PLANS_PAGE.h1}</h1>
        <p className="text-lg text-muted-foreground max-w-2xl mb-12">{PLANS_PAGE.intro}</p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          <div className="p-7 rounded-3xl border border-black/5 bg-white/60" data-testid="plan-free">
            <p className="text-xs uppercase tracking-widest text-[#C8553D] mb-2">Free</p>
            <h2 className="font-display text-3xl mb-1">AI Planner</h2>
            <p className="font-display text-4xl mb-3">A$0</p>
            <p className="text-sm text-muted-foreground mb-5">Unlimited AI itineraries with Google-verified places, live map routes and collaborative editing.</p>
            <Link to="/plan" className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full border border-[#1A3B2B] text-sm" data-testid="plan-free-cta">Start planning <ArrowRight className="w-4 h-4" /></Link>
          </div>
          {PLANS.map((p) => (
            <div key={p.id} id={p.id} className={`p-7 rounded-3xl border ${p.id === "verified" ? "bg-[#1A3B2B] text-[#FDFBF7] border-transparent" : "bg-white/60 border-black/5"}`} data-testid={`plan-${p.id}`}>
              <p className={`text-xs uppercase tracking-widest mb-2 ${p.id === "verified" ? "text-[#C8553D]" : "text-[#C8553D]"}`}>{p.delivery}</p>
              <h2 className="font-display text-3xl mb-1">{p.name}</h2>
              <p className="font-display text-4xl mb-3" data-testid={`plan-${p.id}-price`}>A${p.price_aud}</p>
              <p className={`text-sm mb-5 ${p.id === "verified" ? "opacity-85" : "text-muted-foreground"}`}>{p.tagline}</p>
              <ul className="space-y-2 mb-6 text-sm">
                {p.inclusions.map((x) => <li key={x} className="flex gap-2"><Check className="w-4 h-4 text-[#C8553D] mt-0.5 shrink-0" /> {x}</li>)}
              </ul>
              <CheckoutButton plan={p} label={`Choose ${p.name}`} testId={`plan-${p.id}-cta`} />
              <p className={`text-xs mt-3 ${p.id === "verified" ? "opacity-75" : "text-muted-foreground"}`}>Secure card payment via Stripe. Not sure yet? <Link to={`/plan-with-us?plan=${p.id}`} className="underline">Ask us first</Link>.</p>
            </div>
          ))}
        </div>
        <p className="text-xs text-muted-foreground mt-6">Prices in Australian dollars. Full refund if not delivered within 5 business days — see our <Link to="/refunds" className="underline">refund policy</Link>. Card payments are processed securely by Stripe; WanderlyMe never stores card details.</p>
      </main>
      <Footer />
    </div>
  );
}
